import * as types from "../constants/lexiconsConstants"

const initialState = {
    isModal: false,
    isConfirmationModal: {
        modal: false,
        id: null,
        action: null
    },
    modalType: null,
}

export default function LexiconsReducer(state=initialState, action) {
    switch(action.type) {
        case types.IS_MODAL:
            return {
                ...state,
                isModal: action.payload.isModal,
                isConfirmationModal: state.isConfirmationModal,
                modalType: action.payload.modalType,
            }
        case types.LEXICONS_IS_CONFIRMATION_MODAL:
            return {
                ...state,
                isModal: state.isModal,
                isConfirmationModal: action.payload.isConfirmationModal,
                modalType: state.modalType,
            }
        case types.CLEAN_LEXICONS_CONTEXT:
            return initialState
        default:
            return state
    }
}